module.exports = __webpack_public_path__ + "static/media/18ECA44.b9228a41.jpg";